import ApiClient from "../ApiClient";

const GoogleMeetServices = {

    async connectMeet(code) {
        const resp = await ApiClient.post("/GoogleMeet/oauth/connect", { code });
        return resp.data.data;
    },

    async getConnectionStatus() {
        const resp = await ApiClient.get("/GoogleMeet/oauth/status");
        return resp.data.data;
    },

    async disconnect() {
        const resp = await ApiClient.delete("/GoogleMeet/oauth/disconnect");
        return resp.data.data;
    },

    async createUserMeeting(payload) {
        return ApiClient.post(
            "/GoogleMeet/user/meetings",
            payload
        ).then(r => r.data.data);
    },

    async updateUserMeeting(meetingId, payload) {
        return ApiClient.patch(
            `/GoogleMeet/user/meetings/${encodeURIComponent(meetingId)}`,
            payload
        ).then(r => r.data.data);
    },

    // (future use) Get scheduled meetings
    async getUpcomingMeetings() {
        const resp = await ApiClient.get("/GoogleMeet/meetings/upcoming");
        return resp.data.data;
    },

    async deleteMeeting(meetingId) {
        return ApiClient.delete(`/GoogleMeet/meetings/${meetingId}`)
            .then(r => r.data);
    },

    async deleteExpiredMeetings() {
        return ApiClient.delete(`/GoogleMeet/meetings`).then(r => r.data);
    },

};

export default GoogleMeetServices;
